import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {SessionService} from '../../../shared/services/session.service';
import {PackageService} from '../../../shared/services/package.service';
import {UserService} from '../../../shared/services/user.service';

@Component({
    selector: 'app-my-members',
    templateUrl: './my-members.component.html',
    styleUrls: ['./my-members.component.scss']
})
export class MyMembersComponent implements OnInit {
    showSearch = false;
    searchForm: FormGroup;
    filterForm: FormGroup;
    sessions: any = [];
    myMembers: any = [];
    packages: any = [];
    submitting: any = false;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };

    constructor(private fb: FormBuilder,
                private userService: UserService,
                private packageService: PackageService,
                private sessionService: SessionService) {
    }

    ngOnInit(): void {
        this.refresh();
    }

    refresh() {
        this.searchForm = this.fb.group({
            'name': [''],
            'username': [''],
            'package_id': ['']
        });
        this.filterForm = this.fb.group({
            'session_id': ['']
        });
        this.getSessions();
    }

    getSessions() {
        this.sessions = [];
        this.sessionService.get({'page': -1}).subscribe(data => {
            this.sessions = [];
            if (data && data['data'].length > 0) {
                this.sessions = data['data'];
                if (this.sessions && this.sessions.length > 0) {
                    this.sessions.forEach(session => {
                        if (session && session['status'] === 'ACTIVE' && session['default_session'] === 'ACTIVE') {
                            this.filterForm.patchValue({
                                'session_id': session['id']
                            });
                        }
                    });
                    this.getPackages();
                }
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    getPackages() {
        this.packages = [];
        this.packageService.get({'page': -1}).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.packages = data['data'];
                this.get();
            } else {
                this.packages = [];
            }
        });
    }

    get(params: any = {}) {
        params = {
            'page': this.pagination.page,
            'per_page': this.pagination.perpage,
            'session_id': this.filterForm.value.session_id,
            ...this.searchForm.value
        };
        this.submitting = true;
        this.myMembers = [];
        this.userService.getMyMembers(params).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.myMembers = data['data'];
            }
            this.pagination = {
                page: data.current_page,
                total: data.total,
                perpage: data.per_page,
                pages: data.last_page,
            };
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    search() {
        const params = {
            'name': (this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : '',
            'username': (this.searchForm.value && this.searchForm.value.username) ? this.searchForm.value.username : '',
            'package_id': (this.searchForm.value && this.searchForm.value.package_id) ? this.searchForm.value.package_id : ''
        };
        this.get(params);
    }

    onPageChange(page) {
        this.pagination.page = page;
        const params = {
            'name': (this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : '',
            'username': (this.searchForm.value && this.searchForm.value.username) ? this.searchForm.value.username : '',
            'package_id': (this.searchForm.value && this.searchForm.value.package_id) ? this.searchForm.value.package_id : ''
        };
        this.get(params);
    }
}
